<template>
  <div class="tw:mt-6 tw:mb-6 tw:sm:mb-0">
    <h3 class="tw:font-bold">{{ $t('subscription_cancel_help_header') }}</h3>
    <div
      class="tw:mt-3 tw:border tw:border-gray-300 tw:rounded-xl tw:p-3 tw:flex tw:flex-col tw:sm:flex-row tw:gap-5 tw:items-start tw:sm:items-center tw:sm:justify-between"
    >
      <div class="tw:flex tw:flex-col tw:sm:flex-row tw:gap-x-3 tw:sm:items-center">
        <img :src="MeetingIcon" :alt="$t('subscription_cancel_help_header')" class="tw:h-8 tw:w-8" />
        <div>
          <h6 class="tw:font-bold tw:text-sm">{{ $t('subscription_cancel_help_sutbtext') }}</h6>
          <p class="tw:text-sm">{{ $t('subscription_cancel_help_subline') }}</p>
        </div>
      </div>
      <button
        @click="bookAMeeting"
        class="tw:text-blue-700 tw:font-bold tw:text-sm tw:hover:cursor-pointer tw:hover:underline tw:hover:text-blue-900"
      >
        {{ $t('book_appointment_cta') }}
      </button>
    </div>
  </div>
</template>
<script setup>
import appAnalytics from '@/utils/tracking'

const MeetingIcon = new URL('/src/assets/img/studio-plus/MeetingIcon.svg', import.meta.url)

const props = defineProps({
  accommodationId: Number,
})

const bookAMeeting = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_CHURN_INTRO_BOOK_CS_CLICKED, {
    item_id: props.accommodationId,
  })

  window.open(
    'https://outlook.office365.com/book/TrivagoBussinessPlusHelpmeupgradetoPlus@trvoffice.onmicrosoft.com/',
    '_blank'
  )
}
</script>
